import React from "react";
import Grid from "@mui/material/Grid2";
import EnhancedCard from "common/components/EnhancedCard";
import EnhancedInput from "common/components/EnhancedInput";
import { withStyles } from "@mui/styles";
import get from "lodash/get";
import has from "lodash/has";
import { useTranslation } from "react-i18next";

const NameStep = ({
  classes,
  values,
  errors,
  handleChange,
  status,
  touched,
}) => {
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid size={{ xs: 11 }}>
        <EnhancedCard title={t("offer_create.title")}>
          <Grid size={{ xs: 8 }} className={classes.form}>
            <EnhancedInput
              id="name"
              type="text"
              label={t("offer_create.name_title")}
              caption={t("offer_create.name_subtitle")}
              error={touched.name && has(errors, "name")}
              onChange={handleChange}
              value={values.name}
              helperText={touched.name && get(errors, "name")}
            />
          </Grid>
        </EnhancedCard>
      </Grid>
    </Grid>
  );
};

const styles = (theme) => ({
  form: {
    padding: theme.spacing(1.5),
    maxWidth: 533,
  },
});

export default withStyles(styles)(NameStep);
